import { useState, useEffect, useRef } from 'react';
import { useSnackbar } from "notistack";
import moment from 'moment';
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { checkApiStatus, five_digitHours, convertTimeToDecimal, twoDecimalfn, numberWithCommas, formatCycles } from '../../../utils';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { NoRecordFound, PageLoader, STableLoader, titanAviInstance } from '../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../shared_elements/components';
import { displayDateFormatShort } from '../../../constants';
import { regexConstants } from '../../../constants/regEx';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AttachementsUpload } from '../../../shared_elements/components';
import InfoIcon from '@mui/icons-material/Info';
import { Grid, Button, Paper, TextField, Autocomplete, Table, TableBody, TableCell, TableRow, TableHead, Tooltip, CircularProgress, Box, Typography, Switch, FormControlLabel, Checkbox } from '@mui/material';
import { addUtilizationApi, utilizationDetailUpdateApi, updateUtilizationApi, utilizationTypeApi, utilizationDetailApi, getRegionEscalationApi } from '../apiService';
import { globalPostService, globalPutService, globalGetService } from '../../../utils/globalApiServices';
import { useDispatch, useSelector } from 'react-redux';
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions';
import { fetchLeaseBasicDetails, getStorage } from '../../../shared_elements/actionCreators';
import { trackActivity } from '../../../utils/mixpanel';
import { isMobile } from 'react-device-detect';
import { formatBytes } from '../../../utils/fileUpload';
import { getUtilizationApi } from '../apiService';
import AddThrustSplit from './AddThrustSplit';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { RoleBaseAccess } from '../../../hoc';

const getUtilizationOperationTypes = ({ mode }) => {
    if (mode === 'create' || mode === 'add') return ['C'];
    if (mode === 'view') return ['R'];
    return ['U'];
};

const UtilizationCRU = () => {
    const dispatch=useDispatch()
    const { leaseSlug, utilSlug } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const params = { leaseSlug: leaseSlug };
    const modeForm  = useParams()?.mode
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(location?.state?.data);
    const [cleared, setCleared] = useState(false);
    const [utilType, setUtilType] = useState([])
    const [regionEsc, setRegionEsc] = useState([])
    const [dropDownLoader,setDropDownLoader]=useState({regionEsc:false,utilType:false,})
    const [utilDetail, setUtilDetail] = useState([])
    const [mode, setMode] = useState('');
    const { enqueueSnackbar } = useSnackbar()
    const [attachments, setAttachments] = useState([]);
    const [prevValue, setPrevValue] = useState('')
    const [attachmentsview, setAttachmentsView] = useState({ modal: false, data: null })
    const [skeletonLoader,setSkeletonLoader]=useState(false);
    const { leaseBasicDetails, storageDetails } = useSelector((state) => state.leases);
    const [isDropDownLoading, setIsDropDownLoading] = useState({ storage: false })
    const [addTrustSplit, setAddTrustSplit] = useState({ modal: false, data: null })
    const [forLLpThrustkey, setForLLpThrustkey] = useState({})
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [openLgRow, setOpenLgRow] = useState({});
    const [editableFields, setEditableFields] = useState([]);
    const [tsnCsnCorrection, setTsnCsnCorrection] = useState(false);
    const [enableReconcile, setEnableReconcile] = useState(false);
    const [originalTsnCsn, setOriginalTsnCsn] = useState([]);
    const isLGGrouped = mode === "add" ? leaseBasicDetails?.is_grouped : data?.is_lg_grouped
    const [reportingUtilDate, setReportingUtilDate] = useState(null);
    const startDateTimeoutRef = useRef(null);
    const endDateTimeoutRef = useRef(null);
    const callWithDateDebounce = (dateValue, callApi, timeoutRef) => {
        clearTimeout(timeoutRef.current);
        if (moment(dateValue)?.year() < 1900) {
            timeoutRef.current = setTimeout(callApi, 4000);
        } else {
            callApi();
        }
    };
    useEffect(() => {
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"utilization_master",setIsDropDownLoading}))
        fetchLeaseBasicDetails()
        getRegionEscalation()
        getUtilizationType()
        if (location?.state?.mode) {
            setMode(location?.state?.mode)
        } else {
            setMode(modeForm)
        }
        if (location?.state?.data) {
            setData(location?.state?.data)
            if (location?.state?.mode === 'edit' && [3, 4].includes(location?.state?.data?.utilization_type?.value)) {
                fetchReportingUtilDate();
            }
        } else {
            getUtilizationList()
        }

        if (utilSlug && location?.state?.data?.master_slug) {
            getUtilizationDetailUpdateApi('skeletonLoader','')
        } else {
            if (location?.state?.data) {
                // let todayDate = moment(new Date()).format(backendDateFormat)
                const endDateValue = (location?.state?.data?.end_date) || (location.state?.data?.length > 0 && location.state?.data?.filter(item => item)[0]?.end_date)
                const nextDayDate = endDateValue ? moment(endDateValue).add(1, 'days').format(backendDateFormat) : leaseBasicDetails?.start_date
                getUtilizationDetail('skeletonLoader', nextDayDate, 'firstCall', '')
            }
        }

        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [utilSlug]);

    const extractMinReportingUtilDate = (list = []) => {
        const reportingUtils = list.filter(item => item?.utilization_type?.label === 'Reporting Utilization');
        if (reportingUtils.length === 0) return;
        const minDate = reportingUtils.reduce((min, item) =>
            !min || moment(item.start_date).isBefore(moment(min)) ? item.start_date : min
        , null);
        if (minDate) setReportingUtilDate(minDate);
    };

    const fetchReportingUtilDate = () => {
        globalGetService(getUtilizationApi(params)).then(response => {
            if (checkApiStatus(response)) {
                extractMinReportingUtilDate(response?.data?.data?.list);
            }
        });
    };

    const getUtilizationList = (query = {}) => {
        setLoading(true);
        globalGetService(getUtilizationApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                if (utilSlug && !location?.state?.data?.master_slug) {
                    getUtilizationDetailUpdateApi('skeletonLoader', response?.data?.data?.list?.filter(item => item?.slug === utilSlug)[0]?.master_slug)
                }
                setLoading(false);
                const currentItem = response?.data?.data?.list?.find(item => item?.slug === utilSlug);
                if (modeForm === 'edit' && [3, 4].includes(currentItem?.utilization_type?.value)) {
                    extractMinReportingUtilDate(response?.data?.data?.list);
                }
                if (modeForm === 'create') {
                    setData(response?.data?.data?.list);
                    // let todayDate = moment(new Date()).format(backendDateFormat)
                    const listEndDate = response?.data?.data?.list?.filter(item => item)[0]?.end_date
                    const nextDayDate = listEndDate ? moment(listEndDate).add(1, 'days').format(backendDateFormat) : leaseBasicDetails?.start_date
                    getUtilizationDetail('skeletonLoader', nextDayDate, 'firstCall', '')
                } else {
                    setData(response?.data?.data?.list?.filter(item => item?.slug === utilSlug)[0]);
                    if (!utilSlug) {
                        // let todayDate = moment(new Date()).format(backendDateFormat)
                        const listEndDate = response?.data?.data?.list?.filter(item => item)[0]?.end_date
                        const nextDayDate = listEndDate ? moment(listEndDate).add(1, 'days').format(backendDateFormat) : leaseBasicDetails?.start_date
                        getUtilizationDetail('skeletonLoader', nextDayDate, '', '')
                    }
                }

            } else {
                setLoading(false);
            }
        })
    }
    
    const handleFileChange = (files) => {
        setAttachments(files);
          dispatch(setFileUploadDetails({attachments:files}))
    };
    const onFieldChange = (key, value) => {
        if (key === 'utilization_type') {
            if (!utilSlug) {
                if (value.value === 3) {
                    if (data?.start_date && data?.end_date) {
                        getUtilizationDetail('skeletonLoader', data?.start_date, '', '', value, data?.end_date)
                    }
                } else if (value.value === 4) {
                    if (data?.end_date) {
                        getUtilizationDetail('skeletonLoader', data?.end_date, '', '', value)
                    }
                } else if (data?.start_date && data?.end_date) {
                    getUtilizationDetail('skeletonLoader', data?.start_date, '', 'end_date', null, data?.end_date)
                }
            }
            if ([3, 4, 5].includes(value?.value)) {
                setData({ ...data, [key]: value, 'unit_of_measure': "Number Format", 'escalation_region' : null});
            } else {
                setData({ ...data, [key]: value, 'unit_of_measure': null, 'escalation_region' : null });
            }
            setError({});
            setUtilDetail(prev => {
                return prev.map(item => ({
                    ...item,
                    'unit_of_measure': null,
                    hours: null,
                    cycles: null,
                    entered_hours: null,
                    entered_cycles: null,
                    entered_block_hours: null,
                    table: null,
                    ...(!([3, 4, 5].includes(value?.value)) && {
                        period_start_date: data?.start_date || null,
                        period_end_date: data?.end_date || null,
                    })
                }));
            });
        } else {
            setData({ ...data, [key]: value });
            setError((prev) => ({ ...prev, [key]: '' }));
            if (key === 'end_date') {
                if (key === 'end_date' && !value) {
                    setUtilDetail(prev => {
                        return prev.map(item => ({
                            ...item,
                            period_end_date: null,
                            period_start_date: data?.start_date,
                            hours: 0,
                            cycles: 0,
                            tsn: null,
                            csn: null,
                            entered_cycles: null,
                            entered_block_hours: null,
                            entered_hours: null,
                            unit_of_measure: data?.unit_of_measure || null,
                            asset_location: null,
                            remarks: null,
                            serviceability: null,
                            last_utilization_date: null,
                            utilization_type :null
                        }));
                    });
                } else {
                    if (!utilSlug) {
                        if (data?.utilization_type?.value === 3) {
                            if (data?.start_date) {
                                callWithDateDebounce(value, () => getUtilizationDetail('', data?.start_date, '', '', data?.utilization_type, value), endDateTimeoutRef);
                            }
                        } else if (data?.utilization_type?.value === 4) {
                            callWithDateDebounce(value, () => getUtilizationDetail('', value, '', '', data?.utilization_type), endDateTimeoutRef);
                        } else if (data?.start_date && value) {
                            callWithDateDebounce(value, () => getUtilizationDetail("", data?.start_date, "", "end_date", null, value), endDateTimeoutRef);
                        }
                    }
                    setUtilDetail(prev => {
                        return prev.map(item => ({
                            ...item,
                            'period_end_date': [5, 4, 3].includes(data?.utilization_type?.value) ? null : value
                        }));
                    });
                }
            }
            if (key === 'start_date') {
                setUtilDetail(prev => {
                    return prev.map(item => ({
                        ...item,
                        'period_start_date': [5, 4, 3].includes(data?.utilization_type?.value) ? null : value,
                    }));
                });
                if (!utilSlug && value && data?.end_date) {
                    if (data?.utilization_type?.value === 3) {
                        callWithDateDebounce(value, () => getUtilizationDetail('', value, '', '', data?.utilization_type, data?.end_date), startDateTimeoutRef);
                    } else if (data?.utilization_type?.value !== 4) {
                        callWithDateDebounce(value, () => getUtilizationDetail('', value, '', 'end_date', null, data?.end_date, value), startDateTimeoutRef);
                    }
                }
            }
            if (key === 'unit_of_measure') {
                setUtilDetail(prev => {
                    return prev.map(item => ({
                        ...item,
                        'unit_of_measure': value,
                        hours: null,
                        cycles: null,
                        entered_hours: null,
                        entered_cycles: null,
                        entered_block_hours: null,
                        table: null
                    }));
                });
            }

        }
    };
    const onTableChange = (key, value, index) => {
        setUtilDetail(prev => {
            const updated = [...prev];
            const prevItem = updated[index];
    
            const isUomChange =
                key === "unit_of_measure" &&
                value !== prevItem?.unit_of_measure;
    
            updated[index] = {
                ...prevItem,
                [key]: value,
                ...(isUomChange && {
                    table: null,
                    hours: null,
                    cycles: null,
                    entered_hours: null,
                    entered_cycles: null,
                }),
            };
    
            if (isLGGrouped && prevItem?.asset_type === 4 && [ "hours", "cycles", "entered_hours", "entered_cycles", "period_start_date", "period_end_date","unit_of_measure" ].includes(key)) {
                updated.forEach((row, i) => {
                    if (i !== index && row?.asset_type === 4) {
                        updated[i] = {
                            ...row,
                            [key]: value,
                        };
                    }
                });
            }
    
            return updated;
        });
    
        const errorKey = `row_${index}_${key}`;
        setError(prev => ({
            ...prev,
            [errorKey]: "",
        }));
    };

    
    const getUtilizationType = () => {
        setLoading(true);
        setDropDownLoader(prev => ({ ...prev, utilType: true }));
        globalPostService(utilizationTypeApi(), { "constant_types": ["utilization_type"] })
            .then(response => {
                 setDropDownLoader(prev => ({ ...prev, utilType: false }));
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUtilType(response?.data?.data || []);
                } else {
                    setLoading(false);
                }
            })
    }
    const getRegionEscalation = () => {
        setLoading(true);
         setDropDownLoader(prev => ({ ...prev, regionEsc: true }));
        globalGetService(getRegionEscalationApi(params))
            .then(response => {
                 setDropDownLoader(prev => ({ ...prev, regionEsc: false }));
                if (checkApiStatus(response)) {
                    setLoading(false);
                    const activeRegionEsc=response?.data?.data?.list?.filter(option=> option?.status) || [];
                    setRegionEsc(activeRegionEsc);
                } else {
                    setLoading(false);
                }
            })
    }
    const computeEditableFields = (items) => items.map(item => ({
        tsn: item.is_editable === true && (item.tsn === null || item.tsn === undefined || item.tsn === '' || Number(item.tsn) === 0),
        csn: item.is_editable === true && (item.csn === null || item.csn === undefined || item.csn === '' || Number(item.csn) === 0),
    }));

    const getUtilizationDetail = (loaderType, date, firstCall, endDate, utilizationType, endDateValue, periodStartDate) => {
        loaderType ==='skeletonLoader'? setSkeletonLoader(true):setLoading(true);

        globalGetService(utilizationDetailApi(params, date, endDateValue, utilizationType))
            .then(response => {
                if (checkApiStatus(response)) {

                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                    if (firstCall) {
                        const updatedData = response?.data?.data?.map(item => ({
                            ...item,
                            period_end_date: null,
                            period_start_date: null,
                            hours: null,
                            cycles: null,
                            tsn: null,
                            csn: null,
                            entered_block_hours: null,
                            derate: null,
                            unit_of_measure: null,
                            asset_location: null,
                            remarks: null,
                            serviceability: null,
                            last_utilization_date: null
                        }));
                        setUtilDetail(updatedData);
                        setEditableFields(computeEditableFields(updatedData));
                    } else if(utilizationType){
                        const updatedData = response?.data?.data?.map(item => ({
                            ...item,
                            period_end_date: null,
                            period_start_date: null,
                            hours: null,
                            cycles: null,
                            tsn: item.tsn,
                            csn: item.csn,
                            entered_block_hours: null,
                            derate: item?.derate ?? null,
                            unit_of_measure: null,
                            asset_location: item?.asset_location ?? null,
                            remarks: item?.remarks ?? null,
                            serviceability: item?.serviceability ?? null,
                            egtm: item?.egtm ?? null,
                            last_utilization_date: null
                        }));
                        setUtilDetail(updatedData);
                        setEditableFields(computeEditableFields(updatedData));
                    }
                    else if (endDate) {
                        const globalStartDate = periodStartDate !== undefined ? periodStartDate : data?.start_date;
                        const globalEndDate = endDateValue || date;
                        const updatedData = response?.data?.data?.map(item => ({
                            ...item,
                            period_start_date: item.is_movement_tracker === true ? item.period_start_date : globalStartDate,
                            period_end_date: item.is_movement_tracker === true ? item.period_end_date : globalEndDate,
                            hours: 0,
                            cycles: 0,
                            entered_cycles: null,
                            entered_hours: null,
                            derate: item?.derate ?? null,
                            entered_block_hours: null,
                            unit_of_measure: data?.unit_of_measure || null,
                            asset_location: item?.asset_location ?? null,
                            remarks: item?.remarks ?? null,
                            serviceability: item?.serviceability ?? null,
                            egtm: item?.egtm ?? null,
                        }));
                        setUtilDetail(updatedData);
                        setEditableFields(computeEditableFields(updatedData));
                        setError({})

                    } else {
                        const apiData = response?.data?.data;
                        setUtilDetail(apiData);
                        setEditableFields(computeEditableFields(apiData));
                    }

                } else {
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                    enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                }
            })
    }
    const getUtilizationDetailUpdateApi = (loaderType,masterSlug) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(utilizationDetailUpdateApi(params, (location?.state?.data?.master_slug ? location?.state?.data?.master_slug : masterSlug || masterSlug)))
            .then(response => {
                if (checkApiStatus(response)) {
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                    const assets = response?.data?.data?.details?.assets;
                    setUtilDetail(assets);
                    setEditableFields(computeEditableFields(assets));
                    setForLLpThrustkey(response?.data?.data?.details);
                } else {
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                }
            })

    }

    const combineThrustValues = (rows = [], unitOfMeasure) => {

    if (unitOfMeasure === "Time Format") {

        let totalMinutesHours = 0;
        let totalMinutesCycles = 0;

        rows?.forEach((r) => {
            if (r.hours) {
                const [h = 0, m = 0] = r.hours.split(":").map(Number);
                totalMinutesHours += (h * 60) + m;
            }
            if (r.cycles) {
                const [h = 0, m = 0] = r.cycles.split(":").map(Number);
                totalMinutesCycles += (h * 60) + m;
            }
        });

        const finalHoursH = Math.floor(totalMinutesHours / 60);
        const finalHoursM = totalMinutesHours % 60;

        const finalCyclesH = Math.floor(totalMinutesCycles / 60);
        const finalCyclesM = totalMinutesCycles % 60;

        const format = (h, m) =>
            `${h}:${m.toString().padStart(2, "0")}`;

        return {
            hours: format(finalHoursH, finalHoursM),
            cycles: format(finalCyclesH, finalCyclesM)
        };
    }

    const totalHours = rows?.reduce( (sum, r) => sum + Number(r.hours || 0), 0 );
        const totalCycles = rows?.reduce( (sum, r) => sum + Number(r.cycles || 0), 0 );
        return {
            hours: totalHours.toString(),
            cycles: totalCycles.toString()
        };
};


    useEffect(() => {

        if (!Array.isArray(addTrustSplit?.data)) return;
        if (selectedIndex === null) return;

        const itemUnitOfMeasure = utilDetail[selectedIndex]?.unit_of_measure;
        const { hours, cycles } = combineThrustValues(addTrustSplit?.data, itemUnitOfMeasure);

        setUtilDetail(prev =>
        prev.map((row, i) => {
            if (i !== selectedIndex) return row;

            const isTimeFormat = itemUnitOfMeasure === "Time Format";

            return {
                ...row,
                ...(isTimeFormat
                    ? {
                        entered_hours: hours,
                        entered_cycles: cycles
                      }
                    : {
                        hours,
                        cycles
                      }),
                table: addTrustSplit?.data
            };
        })
    );

    }, [addTrustSplit?.data]);

    const getFieldError = (fieldName, index) => {
        return error[`row_${index}_${fieldName}`] || '';
    };
    
    const onUtilizationAddEdit = () => {
        let validationInputs = {};
        let tableValidations = {};

        validationInputs = {
            start_date: data?.start_date ? '' : "Please select Start Date",
            end_date: data?.end_date ? '' : "Please select End Date",
            unit_of_measure: data?.unit_of_measure ? '' : "Please select Unit of Measure",
            utilization_type: data?.utilization_type?.value ? '' : "Please select Utilization Type",
        };

        const startDate = moment(data?.start_date);
        const endDate = moment(data?.end_date);
        if (data?.start_date && data?.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before start date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after end date";
            }
            if (startDate.isBefore(leaseBasicDetails?.start_date)) {
                validationInputs.start_date = "Start date cannot be before lease start date";
            }
            if (startDate.isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.start_date = "Start date cannot be after lease end date";
            }
            if (endDate.isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.end_date = "End date cannot be after lease end date";
            }
            if (endDate.isBefore(leaseBasicDetails?.start_date)) {
                validationInputs.end_date = "End date cannot be before lease start date";
            }
        }

        if (mode === 'edit' && data?.utilization_type?.value === 4 && reportingUtilDate) {
            const reportingMoment = moment(reportingUtilDate);
            if (data?.start_date && moment(data.start_date).isAfter(reportingMoment)) {
                validationInputs.start_date = "Start Date cannot be later than the Reporting Utilization Start Date.";
            }
            if (data?.end_date && moment(data.end_date).isAfter(reportingMoment)) {
                validationInputs.end_date = "End Date cannot be later than the Reporting Utilization Start Date.";
            }
        }

        if (data?.utilization_type?.value === 3) {
            if (data?.start_date && moment(data.start_date).isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.start_date = "Start Date must be less than or equal to the Lease End Date.";
            }
            if (data?.end_date && moment(data.end_date).isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.end_date = "End Date must be less than or equal to the Lease End Date.";
            }
        }

        if (utilDetail?.length > 0) {
            utilDetail?.forEach((item, index) => {
                tableValidations[`row_${index}_period_start_date`] = [3, 4, 5].includes(data?.utilization_type?.value) || item?.period_start_date ? '' : "Please select Period Start Date";
                tableValidations[`row_${index}_period_end_date`] = [3, 4, 5].includes(data?.utilization_type?.value) || item?.period_end_date ? '' : "Please select Period End Date";

                const tsnFieldName = "tsn";
                const tsnValue = item?.tsn;
                tableValidations[`row_${index}_${tsnFieldName}`] = tsnValue || [6, 2, 1].includes(data?.utilization_type?.value) || mode === 'edit' && tsnValue === 0 ? '' : "Please enter TSN";

                const csnFieldName = "csn";
                const csnValue = item?.csn;

                tableValidations[`row_${index}_${csnFieldName}`] = csnValue || [6, 2, 1].includes(data?.utilization_type?.value) || mode === 'edit' && csnValue === 0 ? '' : "Please enter CSN";
                const isTimeFormat = item?.unit_of_measure === 'Time Format';
                const hasValidHours = isTimeFormat ? item?.entered_hours : item?.hours;
                const hasValidCycles = isTimeFormat ? item?.entered_cycles : item?.cycles;
                tableValidations[`row_${index}_${isTimeFormat ? 'entered_hours' : 'hours'}`] = [5, 4, 3].includes(data?.utilization_type?.value) || item?.asset_type === 2 && item?.llp_multi_thrust === true ? '' : hasValidHours || hasValidHours===0 ? '' : "Please enter Hours";
                tableValidations[`row_${index}_${isTimeFormat ? 'entered_cycles' : 'cycles'}`] = [5, 4, 3].includes(data?.utilization_type?.value) || item?.asset_type === 2 && item?.llp_multi_thrust === true ? '' : hasValidCycles || hasValidCycles===0 ? '' : "Please enter Cycles";
                tableValidations[`row_${index}_unit_of_measure`] = [3, 4, 5].includes(data?.utilization_type?.value) || item?.unit_of_measure ? '' : "Please select Unit of Measure";
                const enterd_h = isTimeFormat ? Number(item?.entered_hours) : (item?.hours === 0 || item?.hours === '0.0') ? null : Number(item?.hours)
                tableValidations[`row_${index}_entered_block_hours`] =
                    [1, 2, 5].includes(data?.utilization_type?.value)
                        ? ''
                        : Number(item?.tsn) === 0 && Number(item.entered_block_hours) === 0 ? ''
                        : Number(item?.entered_block_hours)
                            ? (
                                enterd_h
                                    ? Number(item?.entered_block_hours) > enterd_h
                                        ? ''
                                        : 'BH should be either 0 or Greater than FH'
                                    : Number(item?.entered_block_hours) > Number(item?.tsn)
                                        ? ''
                                        : 'BH should be either 0 or Greater than TSN'
                            )
                            : '';
                if (tsnCsnCorrection && isRowTsnCsnModified(item, index)) {
                    tableValidations[`row_${index}_remarks`] = item?.remarks ? '' : 'Remarks are required when TSN/CSN Changed';
                }
            });
        }

        let payload = Object.assign({}, data)
        let updatePayload = Object.assign({}, data)
        delete updatePayload?.sub_assets
        delete updatePayload?.created_by
        delete updatePayload?.updated_by
        delete updatePayload?.deleted_by
        delete updatePayload?.created_at
        delete updatePayload?.updated_at
        delete updatePayload?.deleted_at
        delete updatePayload?.period_start_date
        delete updatePayload?.period_end_date
        delete updatePayload?.remarks
        delete updatePayload?.asset_location
        delete updatePayload?.serviceability
        delete updatePayload?.asset_name
        delete updatePayload?.entered_hours
        delete updatePayload?.hours
        delete updatePayload?.cycles
        delete updatePayload?.tsn
        delete updatePayload?.csn
        delete updatePayload?.asset_id
        delete updatePayload?.asset_type
        delete updatePayload?.contract_id
        delete updatePayload?.master_id
        delete updatePayload?.id
        delete updatePayload?.slug
        delete updatePayload?.entered_block_hours
        delete updatePayload?.block_hours
        delete updatePayload?.derate
        delete updatePayload?.egtm

      
        const addPayloadData = utilDetail?.length > 0 && utilDetail?.map(({ period_start_date, period_end_date, unit_of_measure,
            hours, cycles, entered_hours, entered_block_hours, block_hours, entered_cycles, serial_number,
            last_utilization_date, asset_type_name, name, is_billable, tsn, csn,table, ...rest }) => ({
                ...rest,
                tsn: tsn || 0,
                csn: csn || 0,
                hours: [5, 4, 3].includes(data?.utilization_type?.value) ? 0 : unit_of_measure === 'Time Format' ? convertTimeToDecimal(entered_hours) : hours || 0,
                cycles: [5, 4, 3].includes(data?.utilization_type?.value) ? 0 : unit_of_measure === 'Time Format' ? convertTimeToDecimal(entered_cycles) : cycles || 0,
                entered_hours: unit_of_measure === 'Time Format' ? entered_hours : null,
                entered_cycles: unit_of_measure === 'Time Format' ? entered_cycles : null,
                entered_block_hours: entered_block_hours || null,
                period_start_date: [5, 4, 3].includes(data?.utilization_type?.value) ? null : period_start_date,
                period_end_date: [5, 4, 3].includes(data?.utilization_type?.value) ? null : period_end_date,
                unit_of_measure: [5, 4, 3].includes(data?.utilization_type?.value) ? data?.unit_of_measure : unit_of_measure,
                thrust_splits: table?.map((row, index) => ({
                  id: row.engine_thrust_types?.id,
                  engine_thrust_type_id: row.engine_thrust_types?.engine_thrust_id,
                  hours: row.hours || 0,
                  cycles: row.cycles || 0,
                  current_thrust: row.current
                 }))
            }));
           
        const updatePayloadData = utilDetail?.length > 0 && utilDetail?.map(({ utilization_type, updated_at,
            created_at, attachments, deleted_by, asset_name, entered_hours, entered_cycles,
            escalation_region, deleted_at, updated_by, created_by, start_date,
            end_date, sub_assets, serial_number, last_utilization_date, asset_type_name,
            name, is_billable, tsn, csn, hours, cycles, unit_of_measure, block_hours, entered_block_hours,table, ...rest }) => ({
                ...rest,
                tsn: tsn || 0,
                csn: csn || 0,
                hours: [5, 4, 3].includes(data?.utilization_type?.value) ? 0 : unit_of_measure === 'Time Format' ? convertTimeToDecimal(entered_hours) : hours || 0,
                cycles: [5, 4, 3].includes(data?.utilization_type?.value) ? 0 : unit_of_measure === 'Time Format' ? convertTimeToDecimal(entered_cycles) : cycles || 0,
                entered_block_hours: entered_block_hours || null,
                entered_hours: unit_of_measure === 'Time Format' ? entered_hours : null,
                entered_cycles: unit_of_measure === 'Time Format' ? entered_cycles : null,
                unit_of_measure: [5, 4, 3].includes(data?.utilization_type?.value) ? data?.unit_of_measure : unit_of_measure,
                enable_reconcile_tsn_csn: enableReconcile,
                thrust_splits: table?.map((row, index) => ({
                  id: row.id,
                  engine_thrust_type_id: row.engine_thrust_types?.id,
                  hours: row.hours || 0,
                  cycles: row.cycles || 0,
                  current_thrust: row.current
                 }))
            }));

        const allValidations = { ...validationInputs, ...tableValidations };
        if (Object.keys(allValidations).every((k) => { return allValidations[k] === ""; })) {
            if (data?.start_date && data?.end_date && data?.unit_of_measure && data?.utilization_type?.value) {
                for (let index = 0; index < utilDetail.length; index++) {

                    const item = utilDetail[index];

                    const isLLPMulti =
                        ![3, 4, 5].includes(data?.utilization_type?.value) &&
                        item?.asset_type === 2 &&
                        (item?.llp_multi_thrust === true ||
                            forLLpThrustkey?.llp_multi_thrust === true);

                    if (isLLPMulti) {

                        const isTimeFormat = item?.unit_of_measure === "Time Format";

                        const hoursValue = isTimeFormat
                            ? item?.entered_hours
                            : item?.hours;

                        const cyclesValue = isTimeFormat
                            ? item?.entered_cycles
                            : item?.cycles;

                        if ( hoursValue == null || hoursValue === "" || cyclesValue == null || cyclesValue === "" ) {
                            enqueueSnackbar(
                                `Please enter Thrust Split for row ${index + 1} (${item?.asset_name || item?.name || "Engine"})`,
                                {
                                    variant: "error",
                                    anchorOrigin: { horizontal: "right", vertical: "top" }
                                }
                            );
                            return; 
                        }
                    }
                }
            }


            setLoading(true);
            if (data?.id) {
                globalPutService(updateUtilizationApi(params), { ...updatePayload,is_lg_grouped : data?.is_lg_grouped ? data?.is_lg_grouped : false, escalation_region: updatePayload?.escalation_region?.name, utilization_type: updatePayload?.utilization_type?.label,  assets: updatePayloadData, enable_reconcile_tsn_csn: enableReconcile }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            dispatch(setUploadFiles({ modal: true, slug: data?.master_slug,mode:'updated' }))
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Utilization`, success_msg: response?.data?.message, item_id: data?.id, payload: updatePayload, response: response?.data })
                        navigate(`/lease/${leaseSlug}/utilization`)
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Utilization`, error_msg: response?.data?.message, item_id: data?.id, payload: updatePayload, response: response?.data })
                    }
                    setLoading(false);
                });
            } else {
                globalPostService(addUtilizationApi(params), {
                    end_date: payload?.end_date || null,
                    start_date: payload?.start_date || null,
                    escalation_region: payload?.escalation_region?.name || null,
                    unit_of_measure: payload?.unit_of_measure || null,
                    utilization_type: payload?.utilization_type?.label, assets: addPayloadData,
                    is_lg_grouped : leaseBasicDetails?.is_grouped ? leaseBasicDetails?.is_grouped :false,
                }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            dispatch(setUploadFiles({ modal: true, slug: response?.data?.data[0]?.master_slug, mode: 'created' }))
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Utilization`, success_msg: response?.data?.message, item_id: response?.data?.data[0]?.id, payload: addPayloadData, response: response?.data })
                        navigate(`/lease/${leaseSlug}/utilization`)
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Utilization`, error_msg: response?.data?.message, item_id: null, payload: addPayloadData, response: response?.data })
                    }
                });
            }
        } else {
            setError(allValidations);
            trackActivity(`Item ${(mode === 'add' || mode === 'create') ? 'Added' : 'Edited'}`, { page_title: `${(mode === 'add' || mode === 'create') ? 'Add' : mode === 'edit' ? 'Edit' : 'View'} Utilization`, error_msg: validationInputs, })
        }
    }

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachmentsView({
            ...attachmentsview, data: {
                ...attachmentsview.data,
                attachments: attachmentsview.data.attachments.filter(item => item?.slug !== deltedslug)
            }
        });
        setData({
            ...data,
            attachments: data.attachments.filter(item => item?.slug !== deltedslug)
        })
    }
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${mode === 'edit' ? "Edit" : mode === 'view' ? "View" : "Add"} Utilization`, page_type: page_type, })
    }

    const isRowTsnCsnModified = (item, index) => {
        if (!tsnCsnCorrection || !originalTsnCsn[index]) return false;
        const origTsn = Number(originalTsnCsn[index]?.tsn) || 0;
        const curTsn = Number(item?.tsn) || 0;
        const origCsn = Number(originalTsnCsn[index]?.csn) || 0;
        const curCsn = Number(item?.csn) || 0;
        return origTsn !== curTsn || origCsn !== curCsn;
    };

    const handleTsnCsnCorrectionToggle = (checked) => {
        if (checked) {
            setOriginalTsnCsn(utilDetail.map(item => ({ tsn: item.tsn, csn: item.csn })));
            setTsnCsnCorrection(true);
        } else {
            setUtilDetail(prev => prev.map((item, i) => ({
                ...item,
                tsn: originalTsnCsn[i]?.tsn,
                csn: originalTsnCsn[i]?.csn,
            })));
            setError(prev => {
                const next = { ...prev };
                utilDetail.forEach((_, i) => { delete next[`row_${i}_remarks`]; });
                return next;
            });
            setOriginalTsnCsn([]);
            setTsnCsnCorrection(false);
            setEnableReconcile(false);
        }
    };
    const mappedRows = utilDetail?.map((row, index) => ({
        ...row,
        index: index
    })) || [];

    const lgRows = isLGGrouped ? mappedRows?.filter((row) => row.asset_type === 4) : [];
    const otherRows = isLGGrouped ? mappedRows?.filter((row) => row.asset_type !== 4) : mappedRows;

    const renderCommonRow = (item, index, rowStyle = {}) => {
    const isGroupedLg = isLGGrouped && item?.asset_type === 4;
    const lgRowIndex = lgRows?.findIndex( (row) => row.asset_id === item?.asset_id );
    const disableGroupedLgFields = isGroupedLg && lgRowIndex > 0;
        return(
        <TableRow
            key={`lg-${index}`}
            sx={{ background: "#f8fbff" }}
        >


            <TableCell>{(mode === 'add' || mode === 'create') ? item?.name : item?.asset_name || "--"}
                <br />
                <span style={{ fontSize: '11px', color: '#8b7777', display: "inline" }}>{item?.last_utilization_date ? moment(item.last_utilization_date).format(displayDateFormatShort) : ''}</span>
            </TableCell>

            {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone) || [3, 4, 5].includes(data?.utilization_type?.value) ? null : <TableCell>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        fullWidth
                        disableFuture
                        minDate={moment(data?.start_date)}
                        maxDate={moment(data?.end_date)}
                        value={item?.period_start_date ? moment(item.period_start_date) : null}
                        onChange={(data) => onTableChange("period_start_date", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null, index)}
                        slotProps={{
                            textField: {
                                InputLabelProps: { shrink: true },
                                size: "small",
                                variant: 'standard',
                                fullWidth: true,
                                error: item.period_start_date ? false : !!getFieldError("period_start_date", index),
                                helperText: item.period_start_date ? '' : getFieldError("period_start_date", index),
                            },
                            field: {
                                clearable: true,
                                onClear: () => {
                                    onTableChange("period_start_date", null);
                                    setCleared(true);
                                }
                            },
                        }}
                        format={fieldDateFormat}
                        disabled={mode === 'view' || tsnCsnCorrection || disableGroupedLgFields || !data?.utilization_type?.value || item?.asset_type === 1}
                    />
                </LocalizationProvider>
            </TableCell>}
            {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone) || [3, 4, 5].includes(data?.utilization_type?.value) ? null : <TableCell>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        fullWidth
                        disableFuture
                        minDate={moment(data?.start_date)}
                        maxDate={moment(data?.end_date)}
                        value={item?.period_end_date ? moment(item.period_end_date) : null}
                        onChange={(data) => onTableChange("period_end_date", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null, index)}
                        slotProps={{
                            textField: {
                                InputLabelProps: { shrink: true },
                                size: "small",
                                variant: 'standard',
                                fullWidth: true,
                                error: item.period_end_date ? false : !!getFieldError("period_end_date", index),
                                helperText: item.period_end_date ? '' : getFieldError("period_end_date", index),

                            },
                            field: {
                                clearable: true,
                                onClear: () => { onTableChange("period_end_date", null); setCleared(true); }
                            },
                        }}
                        format={fieldDateFormat}
                        disabled={mode === 'view' || tsnCsnCorrection || disableGroupedLgFields || !data?.utilization_type?.value || item?.asset_type === 1}
                    />
                </LocalizationProvider>
            </TableCell>}
            <TableCell>
                <TextField
                    id="tsn"
                    variant="standard"
                    size='small'
                    margin='normal'
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 11}}}
                    fullWidth
                    error={item?.tsn ? false : !!getFieldError("tsn", index)}
                    helperText={item?.tsn ? '' : getFieldError("tsn", index)}
                    value={mode === 'edit' || mode === 'view' ? (item?.tsn ? ([1, 2, 6]?.includes(data?.utilization_type?.value) && !editableFields[index]?.tsn && !tsnCsnCorrection ? twoDecimalfn(item?.tsn) : item?.tsn) : item?.tsn === 0 ? item?.tsn : '') :
                        (item?.tsn ? ([1, 2, 6]?.includes(data?.utilization_type?.value) && !editableFields[index]?.tsn && !tsnCsnCorrection ? twoDecimalfn(item?.tsn) : item?.tsn) : '')
                    }
                    onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) && e.target.value <=999999.99 ? onTableChange("tsn", e.target.value, index) : e.preventDefault() }}
                    disabled={mode === "view" || (!tsnCsnCorrection && (!data?.utilization_type?.value || ([6, 2, 1].includes(data?.utilization_type?.value) && !editableFields[index]?.tsn)))}
                />
            </TableCell>
            <TableCell>
                <TextField
                    id="csn"
                    variant="standard"
                    size='small'
                    margin='normal'
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 11} }}
                    fullWidth
                    error={item?.csn ? false : !!getFieldError("csn", index)}
                    helperText={item?.csn ? '' : getFieldError("csn", index)}
                    value={mode === 'edit' || mode === 'view' ? (item?.csn ? ([1, 2, 6]?.includes(data?.utilization_type?.value) && !editableFields[index]?.csn && !tsnCsnCorrection ? twoDecimalfn(item?.csn) : (item?.csn)) : item?.csn === 0 ? (item?.csn) : '') :
                        (item?.csn ? ([1, 2, 6]?.includes(data?.utilization_type?.value) && !editableFields[index]?.csn && !tsnCsnCorrection ? (twoDecimalfn(item?.csn)) : (item?.csn)) : '')
                    }
                    onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) && e.target.value <=999999 ? onTableChange("csn", e.target.value, index) : e.preventDefault() }}
                    disabled={mode === "view" || (!tsnCsnCorrection && (!data?.utilization_type?.value || ([6, 2, 1].includes(data?.utilization_type?.value) && !editableFields[index]?.csn)))}
                />
            </TableCell>
            {[3, 4, 5].includes(data?.utilization_type?.value) ? null : <TableCell>
                <Autocomplete
                    disablePortal
                    options={[1, 2, 6]?.includes(data?.utilization_type?.value) ? ['Time Format', 'Number Format'] : ['Number Format']}
                    getOptionLabel={(option) => option || ""}
                    disabled={mode === "view" || mode === 'edit' || !data?.utilization_type?.value || disableGroupedLgFields  }
                    value={item?.unit_of_measure || null}
                    onChange={(e, value) => onTableChange("unit_of_measure", value, index)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            margin="normal"
                            size="small"
                            variant="standard"
                            required
                            error={item?.unit_of_measure ? false : !!getFieldError("unit_of_measure", index)}
                            helperText={item?.unit_of_measure ? '' : getFieldError("unit_of_measure", index)}
                            slotProps={{ inputLabel: { shrink: true } }}

                        />
                    )}
                />
            </TableCell>}
            {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone) || [1, 2, 5]?.includes(data?.utilization_type?.value) ? null : <TableCell>
                {item?.asset_type !== 1 ? <p >N/A</p> :
                    <TextField
                        id="bh"
                        variant="standard"
                        size="small"
                        margin="normal"
                        slotProps={{ inputLabel: { shrink: true } }}
                        fullWidth
                        placeholder={item?.unit_of_measure === "Time Format" && "HH:MM"}
                        value={mode === 'view' && item?.unit_of_measure !== 'Time Format' && item?.entered_block_hours !== null && item?.entered_block_hours !== undefined && item?.entered_block_hours !== '' ? numberWithCommas(item?.entered_block_hours) : (item?.entered_block_hours ?? '')}
                        error={!!getFieldError("entered_block_hours", index)}
                        helperText={getFieldError("entered_block_hours", index)}
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (item?.unit_of_measure === "Time Format") {
                                const allowedPattern = /^(\d{0,5})(:)?([0-5]?[0-9]?)?$/;
                                if (allowedPattern.test(inputValue) || inputValue === '') {
                                    setPrevValue(inputValue);
                                    onTableChange("entered_block_hours", inputValue, index);
                                }
                            } else {
                            regexConstants.decimalnodotstart.test(e.target.value) && e.target.value <=999999.99 ? 
                            onTableChange("entered_block_hours", e.target.value, index) : e.preventDefault() 
                            }
                        }}
                        disabled={mode === "view" || tsnCsnCorrection || !data?.utilization_type?.value}
                    />}
                <span style={{ fontSize: '11px', color: '#8b7777', display: "inline" }}>{item?.block_hours || item?.last_block_hour_date ? item?.block_hours + ' as of ' + item?.last_block_hour_date : ''}</span>
            </TableCell>}
            {[5, 4, 3]?.includes(data?.utilization_type?.value) ? null : <TableCell>
                <TextField
                    id="hours"
                    variant="standard"
                    size="small"
                    margin="normal"
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    placeholder={item?.unit_of_measure === "Time Format" && "HH:MM"}
                    value={item?.unit_of_measure === "Time Format" ? (item?.entered_hours ?? '') : (mode === 'view' && item?.hours !== null && item?.hours !== undefined && item?.hours !== '' ? numberWithCommas(item?.hours) : (item?.hours ?? ''))}
                    error={!!getFieldError(item?.unit_of_measure === "Time Format" ? "entered_hours" : "hours", index)}
                    helperText={getFieldError(item?.unit_of_measure === "Time Format" ? "entered_hours" : "hours", index)}
                    onChange={(e) => {
                        const inputValue = e.target.value;
                        if (item?.unit_of_measure === "Time Format") {
                            const allowedPattern = /^(\d{0,5})(:)?([0-5]?[0-9]?)?$/;
                            if (allowedPattern.test(inputValue) || inputValue === '') {
                                setPrevValue(inputValue);
                                onTableChange("entered_hours", inputValue, index);
                            }
                        } else {
                             regexConstants.decimalnodotstart.test(e.target.value) && e.target.value <=999999.99 ? 
                             onTableChange("hours", e.target.value, index) : e.preventDefault() 
                        }
                    }}
                    disabled={mode === "view" || tsnCsnCorrection || disableGroupedLgFields || !data?.utilization_type?.value || item?.asset_type === 2 && item?.llp_multi_thrust === true || item?.asset_type === 2 && forLLpThrustkey?.llp_multi_thrust === true}
                />
                {item?.asset_type === 2 && item?.llp_multi_thrust === true || item?.asset_type === 2 && forLLpThrustkey?.llp_multi_thrust === true ? <Button disabled={!data?.unit_of_measure || tsnCsnCorrection} size='small' sx={{ textTransform: "capitalize" }} onClick={() => { setAddTrustSplit(prev => ({ modal: true, data: item })); setSelectedIndex(index); }}>{mode === 'edit' ? "Edit Thrust Split" : mode === 'add' ? "Add Thrust Split" : "View Thrust Split"}</Button> : null}
            </TableCell>}
            {[5, 4, 3]?.includes(data?.utilization_type?.value) ? null : <TableCell>
                <TextField
                    id="cycles"
                    variant="standard"
                    size='small'
                    margin='normal'
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    placeholder={item?.unit_of_measure === "Time Format" && "HH:MM"}
                    value={item?.unit_of_measure === "Time Format" ? (item?.entered_cycles ?? '') : (mode === 'view' && item?.cycles !== null && item?.cycles !== undefined && item?.cycles !== '' ? formatCycles(item?.cycles) : (item?.cycles ?? ''))}
                    error={!!getFieldError(item?.unit_of_measure === "Time Format" ? "entered_cycles" : "cycles", index)}
                    helperText={getFieldError(item?.unit_of_measure === "Time Format" ? "entered_cycles" : "cycles", index)}
                    onChange={(e) => {
                        const inputValue = e.target.value;
                        if (item?.unit_of_measure === "Time Format") {
                            const allowedPattern = /^(\d{0,5})(:)?([0-5]?[0-9]?)?$/;
                            if (allowedPattern.test(inputValue) || inputValue === '') {
                                setPrevValue(inputValue);
                                onTableChange("entered_cycles", inputValue, index);
                            }
                        } else {
                             regexConstants.decimalnodotstart.test(e.target.value) && e.target.value <=999999.99 ? 
                             onTableChange("cycles", e.target.value, index) : e.preventDefault() 
                        }
                    }}
                    disabled={mode === "view" || tsnCsnCorrection || disableGroupedLgFields || !data?.utilization_type?.value || item?.asset_type === 2 && item?.llp_multi_thrust === true || item?.asset_type === 2 && forLLpThrustkey?.llp_multi_thrust === true}
                />
                {item?.asset_type === 2 && item?.llp_multi_thrust === true || item?.asset_type === 2 && forLLpThrustkey?.llp_multi_thrust === true ? <Button disabled={!data?.unit_of_measure || tsnCsnCorrection} size='small' sx={{ textTransform: "capitalize" }} onClick={() => { setAddTrustSplit(prev => ({ modal: true, data: item })); setSelectedIndex(index); }}> {mode === 'edit' ? "Edit Thrust Split" : mode === 'add' ? "Add Thrust Split" : "View Thrust Split"}</Button> : null}
            </TableCell>}
            {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone && utilDetail[0]?.asset_type !== 2) ? null : <TableCell>
                {item?.asset_type !== 2 ? <p >N/A</p> :
                    <TextField
                        id="derate"
                        variant="standard"
                        size='small'
                        margin='normal'
                        slotProps={{ inputLabel: { shrink: true } }}
                        fullWidth
                        value={mode === 'view' && item?.derate !== null && item?.derate !== undefined && item?.derate !== '' ? numberWithCommas(item?.derate) : (item?.derate ?? '')}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (regexConstants.derateRegex.test(val)) {
                                onTableChange("derate", val, index);
                            }
                        }}
                        disabled={mode === "view" || tsnCsnCorrection || !data?.utilization_type?.value}
                    />}
            </TableCell>}
            {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone && utilDetail[0]?.asset_type !== 2) ? null : <TableCell>
                {item?.asset_type !== 2 ? <p >N/A</p> :
                    <TextField
                        id="egtm"
                        variant="standard"
                        size='small'
                        margin='normal'
                        slotProps={{ inputLabel: { shrink: true } }}
                        fullWidth
                        value={mode === 'view' && item?.egtm !== null && item?.egtm !== undefined && item?.egtm !== '' ? numberWithCommas(item?.egtm) : (item?.egtm ?? '')}
                        onChange={(e) => { regexConstants?.numberWithDot.test(e.target.value) ? onTableChange("egtm", e.target.value, index) : e.preventDefault() }}
                        disabled={mode === "view" || tsnCsnCorrection || !data?.utilization_type?.value}
                    />}
            </TableCell>}
            <TableCell>
                <TextField
                    id="asset_location"
                    variant="standard"
                    size='small'
                    margin='normal'
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    value={item?.asset_location || ''}
                    onChange={(e) => onTableChange("asset_location", e.target.value, index)}
                    disabled={mode === "view" || tsnCsnCorrection}
                />
            </TableCell>
            <TableCell>
                <TextField
                    id="remarks"
                    variant="standard"
                    size='small'
                    margin='normal'
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    value={item?.remarks || ''}
                    error={tsnCsnCorrection && isRowTsnCsnModified(item, index) && !item?.remarks ? !!getFieldError("remarks", index) : false}
                    helperText={tsnCsnCorrection && isRowTsnCsnModified(item, index) && !item?.remarks ? getFieldError("remarks", index) : ''}
                    onChange={(e) => {
                        onTableChange("remarks", e.target.value, index);
                        if (tsnCsnCorrection && isRowTsnCsnModified(item, index) && e.target.value) {
                            setError(prev => ({ ...prev, [`row_${index}_remarks`]: '' }));
                        }
                    }}
                    disabled={mode === "view"}
                />
            </TableCell>
            <TableCell>
                <TableCell>
                    <TextField
                        id="serviceability"
                        variant="standard"
                        size='small'
                        margin='normal'
                        slotProps={{ inputLabel: { shrink: true } }}
                        fullWidth
                        value={item?.serviceability || ''}
                        onChange={(e) => onTableChange("serviceability", e.target.value, index)}
                        disabled={mode === "view" || tsnCsnCorrection}
                    />
                </TableCell>
            </TableCell>
        </TableRow>
    )}

    return (
        <>
        <LeasesBasicDetails />
        <Paper className='cru-utilization-section lease-details-section lease-module-paper' elevation={0}  sx={{height: 'calc(100vh - 195px)', padding: "1px 3px 0px 0px", marginTop:"10px", display: 'flex',flexDirection: 'column',overflow: 'hidden'}}>
            <LeasesNav />
            {leaseBasicDetails?.status === "Draft" ? <ModuleNotExcessModal moduleName="Utilization" /> : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
            <div className='lease-details-content utilization-cru-table' style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative' }}>
                
                <Paper square className="responsive-paper" sx={{mb: 0}}>
                    <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                        <Grid item md={4} xs={12} className="menu-container" position="relative" top={isMobile ? "20px" : null}>
                            <span onClick={() => { navigate(`/lease/${leaseSlug}/utilization`); handleItemClicked(' ArrowBackIcon') }} style={{ color: "#1976d2", cursor: 'pointer', fontSize: "14px", fontWeight: "bold", fontFamily: "Roboto" }}>
                                <Tooltip title="Back"> <ArrowCircleLeftOutlinedIcon sx={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '8px' }} color='primary' fontSize='small' /> </Tooltip>
                            </span>
                            <span style={{ color: "#1976d2", fontSize: "14px", fontWeight: "bold", fontFamily: "Roboto" }}>{mode === 'edit' ? "Edit Utilization" : mode === 'view' ? "View Utilization" : "Add Utilization"}</span>
                        </Grid>
                        <Grid item md={8} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            {mode === 'edit' && ![3, 4].includes(data?.utilization_type?.value) && (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={tsnCsnCorrection}
                                            onChange={(e) => handleTsnCsnCorrectionToggle(e.target.checked)}
                                            color="primary"
                                            size="small"
                                        />
                                    }
                                    label="TSN/CSN Manual Correction"
                                    sx={{ mr: 1, '& .MuiFormControlLabel-label': { fontSize: '13px', fontWeight: 500 } }}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Paper>
                <>
                    <div className='utilization-item-container tab-detail-container' style={{paddingTop:'5px'}}>
                        <Grid container spacing={2} className="utilization-input-item">
                            <Grid size={{ md: 2.4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    options={(dropDownLoader?.utilType || skeletonLoader ) ? [] : utilType || []}
                                    getOptionLabel={(option) => option?.label || ""}
                                    noOptionsText={dropDownLoader?.utilType ? "loading" : "No Option Available"}
                                    disabled={mode === 'view' || mode === 'edit'}
                                    value={data?.utilization_type || null}
                                    onChange={(e, value) => onFieldChange("utilization_type", value)}
                                    onFocus={() => onRestErrorKey("utilization_type")}
                                    getOptionDisabled={(option) => {
                                        const status = utilDetail?.[0]?.status || {};
                                        if (!status || typeof status !== 'object') return false;
                                        if (option?.value === 3 && status["CTA Entry for Return"]) return true;
                                        if (option?.value === 4 && status["CTA Entry for Delivery"]) return true;
                                        return false;
                                    }}
                                    renderInput={(params) => {
                                        const selectedLabel = params?.inputProps?.value || "";
                                        return (
                                        <Tooltip title={selectedLabel.length > 20 ? selectedLabel : ""} placement="bottom" arrow >
                                        <TextField
                                            {...params}
                                            label="Utilization Type"
                                            margin='normal'
                                            size='small'
                                            fullWidth
                                            required
                                            error={!!error.utilization_type}
                                            helperText={error.utilization_type}
                                            slotProps={{
                                                inputLabel: { shrink: true, },
                                                input: {
                                                    ...params?.InputProps, endAdornment: (<>{dropDownLoader?.utilType || skeletonLoader ? (<CircularProgress color="inherit" size={20} />) : null}
                                                        {params?.InputProps?.endAdornment}
                                                    </>
                                                    )
                                                }
                                            }}
                                        />
                                    </Tooltip>)}}
                                />
                            </Grid>
                            <Grid size={{ md: 2.4, xs: 12 }}>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        label="Start Date"
                                        fullWidth
                                        disableFuture={data?.utilization_type?.value !== 3}
                                        minDate={moment(leaseBasicDetails?.start_date)}
                                        maxDate={data?.utilization_type?.value === 3 ? moment(leaseBasicDetails?.end_date) : (mode === 'edit' && data?.utilization_type?.value === 4 && reportingUtilDate ? moment(reportingUtilDate) : undefined)}
                                        value={data?.start_date ? moment(data.start_date) : null}
                                        onChange={(data) => onFieldChange("start_date", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                        slotProps={{
                                            textField: {
                                                InputLabelProps: { shrink: true },
                                                required: true,
                                                size: "small",
                                                fullWidth: true,
                                                error: error.start_date || false,
                                                helperText: error.start_date || '',
                                                onFocus: () => {
                                                    if (error.start_date) {
                                                        onRestErrorKey("start_date");
                                                    }
                                                }
                                            },
                                            field: { clearable: true, onClear: () => { onFieldChange("start_date", null); setCleared(true); onRestErrorKey("start_date"); } },
                                        }}
                                        format={fieldDateFormat}
                                        disabled={mode === 'view' || tsnCsnCorrection || (mode === 'edit' && ![3, 4].includes(data?.utilization_type?.value))}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid size={{ md: 2.4, xs: 12 }}>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        label="End Date"
                                        disableFuture={data?.utilization_type?.value !== 3}
                                        minDate={moment(data?.start_date)}
                                        maxDate={data?.utilization_type?.value === 3 ? moment(leaseBasicDetails?.end_date) : (mode === 'edit' && data?.utilization_type?.value === 4 && reportingUtilDate ? moment(reportingUtilDate) : undefined)}
                                        value={data?.end_date ? moment(data.end_date) : null}
                                        onChange={(data) => onFieldChange("end_date", moment(data)?.isValid() ? moment(data).format(backendDateFormat) : null)}
                                        slotProps={{
                                            textField: {
                                                InputLabelProps: { shrink: true },
                                                required: true,
                                                size: "small",
                                                fullWidth: true,
                                                error: error.end_date || false,
                                                helperText: error.end_date || '',
                                                onFocus: () => {
                                                    if (error.end_date) {
                                                        onRestErrorKey("end_date");
                                                    }
                                                }
                                            },
                                            field: { clearable: true, onClear: () => { onFieldChange("end_date", null); setCleared(true); onRestErrorKey("end_date"); } },
                                        }}
                                        format={fieldDateFormat}
                                        disabled={mode === 'view' || tsnCsnCorrection || (mode === 'edit' && ![3, 4].includes(data?.utilization_type?.value))}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid size={{ md: 2.4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    options={[1, 2, 6].includes(data?.utilization_type?.value) ? ['Time Format', 'Number Format'] : [3, 4, 5].includes(data?.utilization_type?.value) ? ['Number Format'] : ['Time Format', 'Number Format']}
                                    getOptionLabel={(option) => option || ""}
                                    disabled={mode === 'view' || mode === 'edit' || [3, 4, 5]?.includes(data?.utilization_type?.value)}
                                    value={data?.unit_of_measure || null}
                                    onChange={(e, value) => onFieldChange("unit_of_measure", value)}
                                    onFocus={() => onRestErrorKey("unit_of_measure")}
                                    renderInput={(params) => {
                                        const selectedLabel = params?.inputProps?.value || "";
                                        return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                        <TextField
                                            {...params}
                                            label="Unit of Measure"
                                            margin="normal"
                                            size="small"
                                            fullWidth
                                            required
                                            error={data?.unit_of_measure?.value || data?.unit_of_measure  ? false : !!error.unit_of_measure}
                                            helperText={data?.unit_of_measure?.value || data?.unit_of_measure ? '' : error.unit_of_measure}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                        />
                                    </Tooltip>)}}
                                />
                            </Grid>
                            <Grid size={{ md: 2.4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={regionEsc || []}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={dropDownLoader?.regionEsc ? "loading" : "No Option Available"}
                                    disabled={mode === 'view' || tsnCsnCorrection || ![1, 2, 6].includes(data?.utilization_type?.value)}
                                    value={data?.escalation_region || null}
                                    onChange={(e, value) => onFieldChange("escalation_region", value)}
                                    renderInput={(params) => {
                                        const selectedLabel = params?.inputProps?.value || "";
                                        return (
                                            <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                        <TextField
                                            {...params}
                                            label="Region of Operation"
                                            margin='normal'
                                            size='small'
                                            fullWidth
                                            disabled={mode === 'view'}
                                            slotProps={{
                                                inputLabel: { shrink: true, },
                                                input: {
                                                    ...params?.InputProps, endAdornment: (<>{dropDownLoader?.regionEsc ? (<CircularProgress color="inherit" size={20} />) : null}
                                                        {params?.InputProps?.endAdornment}
                                                    </>
                                                    )
                                                }
                                            }}
                                        />
                                    </Tooltip>)}}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', }}>
                            <Grid size={{ md: 12, xs: 12, sm: 12 }} sx={{ overflow: 'auto' }}>
                                {skeletonLoader ? <STableLoader count={8} rowCount={9} /> : 
                                <div style={{ overflowY: 'auto' }}>
                                    <Table className="mui-table-format" stickyHeader sx={{ overflow: 'auto', padding: '0px 0px 0px 3px' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ minWidth: '120px' }}> Assembly </TableCell>
                                                {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone) || [3, 4, 5].includes(data?.utilization_type?.value) ? null : <TableCell sx={{ minWidth: '170px' }}> Start Date {mode === 'view' || mode === 'edit' || !data?.utilization_type?.value ? null :<span style={{ color: 'red', verticalAlign: 'sup' }}>*</span>}</TableCell>}
                                                {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone) || [3, 4, 5].includes(data?.utilization_type?.value) ? null : <TableCell sx={{ minWidth: '170px' }}> End Date {mode === 'view' || mode === 'edit' || !data?.utilization_type?.value  ? null :<span style={{ color: 'red', verticalAlign: 'sup' }}>*</span>}</TableCell>}
                                                <TableCell sx={{ minWidth: '100px' }}> TSN as Of {[6, 2, 1].includes(data?.utilization_type?.value) ? null : <span style={{ color: 'red', verticalAlign: 'sup' }}>*</span>}</TableCell>
                                                <TableCell sx={{ minWidth: '100px' }}> CSN as Of {[6, 2, 1].includes(data?.utilization_type?.value) ? null : <span style={{ color: 'red', verticalAlign: 'sup' }}>*</span>}</TableCell>
                                                {[3, 4, 5].includes(data?.utilization_type?.value) ? null : <TableCell sx={{ minWidth: '180px' }}> Unit of Measure <span style={{ color: 'red', verticalAlign: 'sup' }}>*</span></TableCell>}
                                                {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone )|| [1, 2, 5].includes(data?.utilization_type?.value) ? null : <TableCell sx={{ minWidth: '120px' }}> BH <Tooltip placement='top' title="Block Hours"><InfoIcon sx={{ cursor: 'pointer', fontSize: 'small' }} color="primary" fontSize="small" /></Tooltip></TableCell>}
                                                {[5, 4, 3].includes(data?.utilization_type?.value) ? null : <TableCell sx={{ minWidth: '140px' }}> Flight Hours <span style={{ color: 'red', verticalAlign: 'sup' }}>*</span></TableCell>}
                                                {[5, 4, 3].includes(data?.utilization_type?.value) ? null : <TableCell sx={{ minWidth: '140px' }}> Flight Cycle <span style={{ color: 'red', verticalAlign: 'sup' }}>*</span></TableCell>}
                                                {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone && utilDetail[0]?.asset_type !== 2) ? null : <TableCell sx={{ minWidth: '120px' }}> DeRate <span ></span></TableCell>}
                                                {(utilDetail?.length > 0 && utilDetail[0]?.stand_alone && utilDetail[0]?.asset_type !== 2) ? null : <TableCell sx={{ minWidth: '120px' }}> EGTM <Tooltip placement='top' title="EGT Margin"><InfoIcon sx={{ cursor: 'pointer', fontSize: 'small' }} color="primary" fontSize="small" /></Tooltip></TableCell>}
                                                <TableCell sx={{ minWidth: '140px' }}> Location</TableCell>
                                                <TableCell sx={{ minWidth: '130px' }}> Remarks{tsnCsnCorrection ? <span style={{ color: 'red', verticalAlign: 'sup' }}>*</span> : null}</TableCell>
                                                <TableCell sx={{ minWidth: '140px' }}> Serviceability</TableCell>
                                            </TableRow>
                                        </TableHead>
                                                    <TableBody>
                                                        {otherRows?.length>0 && otherRows?.map((item) =>
                                                            renderCommonRow(item, item.index)
                                                        )}
                                                        {lgRows?.length > 0 && (
                                                            <>
                                                                <TableRow>
                                                                    <TableCell colSpan={20} onClick={() => setOpenLgRow(!openLgRow)} sx={{ cursor: "pointer", background: "#eef3fb", py: 1.5, }} >
                                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                            <Typography sx={{ fontSize: "18px", minWidth: "20px" }}>
                                                                                { openLgRow ? ( <KeyboardArrowDownIcon sx={{ fontSize: "24px", minWidth: "20px", color: "#000", verticalAlign: "middle", }} /> ) : ( <KeyboardArrowRightIcon sx={{ fontSize: "24px", minWidth: "20px", color: "#000", verticalAlign: "middle", }} /> ) }
                                                                            </Typography>
                                                                            <Box
                                                                                sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", }}
                                                                            >
                                                                                <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#000", }} > Landing Gears (LG) </Typography>
                                                                                <Box sx={{ px: 1.2, py: 0.2, borderRadius: "16px", background: "#1f5ea8", color: "#fff", fontSize: "11px", fontWeight: 600, lineHeight: 1.8, }} > GROUPED </Box>
                                                                                <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#000", }} > ({lgRows.map((_, i) => `LG${i + 1}`).join(" · ")}) </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </TableCell>
                                                                </TableRow>
                                                                {openLgRow && lgRows.map((item) => renderCommonRow( item, item.index, { background: "#f8fbff" } ) )}
                                                            </>
                                                        )}
                                                    </TableBody>
                                    </Table>
                                </div>}
                                {!skeletonLoader && !utilDetail?.length && <NoRecordFound />}
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
                            <Grid size={{ md: 12, sm: 12, xs: 12, }}>
                                {tsnCsnCorrection && (
                                    <FormControlLabel
                                        control={<Checkbox checked={enableReconcile} onChange={(e) => setEnableReconcile(e.target.checked)} color="primary" size="small" disableRipple />}
                                        label="Enable Reconcile for TSN/CSN"
                                        sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', fontWeight: 500 } }}
                                    />
                                )}
                            </Grid>
                            <Grid size={{ md: 12, sm: 12, xs: 12, }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }} >
                                    {data?.id && data?.attachments?.length ? <div>
                                        <Button onClick={() => { setAttachmentsView({ modal: true, data: data }); handleItemClicked('ViewAttachments Button') }} sx={{ margin: '3px 0px' }} size='small' variant='outlined' color='primary' > ({data?.attachments?.length}) Attachment(s) </Button> </div> : null
                                    }
                                    <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary' endIcon={isDropDownLoading?.storage ? <ButtonLoader size={15}/>:null}>{`Available Space : ${isDropDownLoading?.storage ?"":formatBytes(storageDetails?.remaining_storage)}`}</Button>
                                    </Box>
                                <div style={{ maxHeight: '300px', marginTop: data?.id && data?.attachments?.length ? '' : '30px' }}>
                                    {mode === 'view' ? (
                                        <Box sx={{ border: "2px dashed #ccc", borderRadius: "8px", p: 3, textAlign: "center", cursor: "not-allowed", backgroundColor: "#fafafa", }} >
                                            <Typography style={{ fontSize: "13px" }}>
                                                Drag and drop, or click here to upload file(s)
                                            </Typography>
                                        </Box>
                                    ):  <div style={{ marginTop: '8px' }}>
                                            <AttachementsUpload onFileChange={handleFileChange} isDisabled={mode === 'view'} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage}/>
                                        </div>}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <Box sx={{ position: 'sticky', bottom: 0, left: 0, right: 0, backgroundColor: '#fff', borderTop: '1px solid #e0e0e0', padding: '8px 4px', display: 'flex', justifyContent: 'flex-end', gap: 1, zIndex: 10, boxShadow: '0 -2px 8px rgba(0,0,0,0.1)', marginTop: 'auto' }}>
                        <Button variant='outlined' disabled={isLoading} size='small' onClick={() => { navigate(`/lease/${leaseSlug}/utilization`); handleItemClicked('Cancel Button') }} sx={{ marginRight: '0px' }} > {mode !== "view" ? "Cancel" : "Close"} </Button>
                        {mode === 'view' ? null : <Button variant='contained' size='small' className='btn-primary' disabled={skeletonLoader}  onClick={() => { handleItemClicked('Save Button'); onUtilizationAddEdit()}} > Save </Button>}
                    </Box> 
                </>
            </div>}
            {attachmentsview.modal ?
                <ShowAttachments
                    moduleName="Utilization"
                    url='lease/utilization'
                    attachmentsData={attachmentsview}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachmentsView({ modal: false, data: null })}
                    onViewDisabled={true}
                    permissionKey='utilization'
                /> : null
            }
              {addTrustSplit?.modal ? 
                    <AddThrustSplit
                        params={params}
                        modeForm={modeForm}
                        addTrustSplit={addTrustSplit}
                        mode={mode}
                        selectedIndex={selectedIndex}
                        utilDetail={utilDetail}
                        format={addTrustSplit?.data?.unit_of_measure || data?.unit_of_measure}
                        toggleModalFn={(rows) => {
                            if (rows) {
                                setAddTrustSplit({ modal: false, data: rows }); 
                            } else {
                                setAddTrustSplit({ modal: false, data: null }); 
                            }
                        }}
                    /> 
               : null }
            {isLoading ? <PageLoader /> : null}
        </Paper>
        </>
    )
}
export default RoleBaseAccess(UtilizationCRU, { application: 'lease_revamp', feature: 'utilization', operationType: getUtilizationOperationTypes });
